import React, { useEffect, useState } from 'react'
import { FaArrowLeft, FaTimes } from 'react-icons/fa';
import { apiPut } from '../../API/Api_Url';
import { toast } from 'react-toastify';

function UpdateLobourJobPostModel({ SelectedReq, isOpen, onClose, GetUserAllPendingLabourJobPost }) {

    const [IsLoading, setIsLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [Skillsrequire, setSkillsrequire] = useState([]);
    const [skillInput, setSkillInput] = useState("");
    const [Address, setAddress] = useState("");
    const [City, setCity] = useState("");
    const [State, setState] = useState("");
    const [NumberOfLabours, setNumberOfLabours] = useState("");
    const [DurationInDays, setDurationInDays] = useState("");
    const [PerDayRate, setPerDayRate] = useState("");
    const [Notes, setNotes] = useState("");

    useEffect(() => {
        if (SelectedReq) {
            setSkillsrequire(SelectedReq?.Skillsrequire || []);
            setAddress(SelectedReq?.Location?.Address || "");
            setCity(SelectedReq?.Location?.City || "");
            setState(SelectedReq?.Location?.State || "");
            setNumberOfLabours(SelectedReq?.NumberOfLabours || "");
            setDurationInDays(SelectedReq?.DurationInDays || "");
            setPerDayRate(SelectedReq?.PerDayRate || "");
            setNotes(SelectedReq?.Notes || "");
        }
    }, [SelectedReq]);


    const handleAddSkill = () => {
        if (skillInput.trim() && !Skillsrequire.includes(skillInput.trim())) {
            setSkillsrequire([...Skillsrequire, skillInput.trim()]);
        }
        setSkillInput("");
    };

    const handleRemoveSkill = (skill) => {
        setSkillsrequire(Skillsrequire.filter((s) => s !== skill));
    };


    const handleUpdateLobourJobPost = async () => {
        let newErrors = {};

        if (Skillsrequire.length === 0) newErrors.Skillsrequire = "Skills are required";
        if (!Address.trim()) newErrors.Address = "Address is required";
        if (!City.trim()) newErrors.City = "City is required";
        if (!State.trim()) newErrors.State = "State is required";
        if (!NumberOfLabours) newErrors.NumberOfLabours = "Number of labours is required";
        if (!DurationInDays) newErrors.DurationInDays = "Duration in days is required";
        if (!PerDayRate) newErrors.PerDayRate = "Per day rate is required";

        setErrors(newErrors);
        if (Object.keys(newErrors).length > 0) return;

        const payload = {
            Skillsrequire,
            Location: {
                Address,
                City,
                State,
            },
            NumberOfLabours: Number(NumberOfLabours),
            DurationInDays: Number(DurationInDays),
            PerDayRate: Number(PerDayRate),
            Notes,
        };

        try {
            setIsLoading(true);
            const response = await apiPut(
                `/api/user/UserUpdateLabourJobRequirement/${SelectedReq?._id}`,
                payload
            );
            if (response?.data) {
                toast.success(
                    response?.data?.message ||
                    response?.message ||
                    "Job post Updated successfully!"
                );
                onClose()
                GetUserAllPendingLabourJobPost()
            } else {
                toast.error(response?.message || "Failed to create job post");
            }
        } catch (error) {
            console.error("Error uploading requirement:", error);
            toast.error("Something went wrong. Please try again.");
        } finally {
            setIsLoading(false);
        }
    }

    if (!isOpen) return null;
    return (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white rounded-2xl shadow-lg p-8 max-w-4xl w-full overflow-y-auto max-h-[90vh]">
                <div className="flex items-center mb-6">
                    <FaArrowLeft
                        className="mr-3 cursor-pointer text-gray-600 hover:text-gray-800 transition"
                        onClick={onClose}
                    />
                    <h2 className="text-2xl font-semibold text-gray-800">Update Lobour Job Post</h2>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-5 pt-5">
                    <div className="md:col-span-2">
                        <label className="block mb-1 font-medium">
                            Skills<span className="text-red-500">*</span>
                        </label>
                        <div className="flex gap-2 mb-2">
                            <input
                                className="form-input flex-1"
                                type="text"
                                placeholder="e.g. Mason, Helper"
                                value={skillInput}
                                onChange={(e) => setSkillInput(e.target.value)}
                                onKeyDown={(e) =>
                                    e.key === "Enter" && (e.preventDefault(), handleAddSkill())
                                }
                            />
                            <button
                                type="button"
                                onClick={handleAddSkill}
                                className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition"
                            >
                                Add
                            </button>
                        </div>
                        <div className="flex flex-wrap gap-2">
                            {Skillsrequire?.map((skill, idx) => (
                                <span
                                    key={idx}
                                    className="px-3 py-1 bg-blue-100 text-blue-700 rounded-full flex items-center gap-2 text-sm"
                                >
                                    {skill}
                                    <FaTimes
                                        className="cursor-pointer hover:text-red-500"
                                        onClick={() => handleRemoveSkill(skill)}
                                    />
                                </span>
                            ))}
                        </div>
                        {errors?.Skillsrequire && (
                            <p className="text-red-500 text-sm mt-1">{errors?.Skillsrequire}</p>
                        )}
                    </div>

                    <div>
                        <label className="block mb-1 font-medium">
                            Address<span className="text-red-500">*</span>
                        </label>
                        <input
                            className={`form-input w-full ${errors?.Address ? "border-red-500" : ""}`}
                            type="text"
                            placeholder="Enter Address"
                            value={Address}
                            onChange={(e) => setAddress(e.target.value)}
                        />
                        {errors?.Address && (
                            <p className="text-red-500 text-sm mt-1">{errors?.Address}</p>
                        )}
                    </div>
                    <div>
                        <label className="block mb-1 font-medium">
                            City<span className="text-red-500">*</span>
                        </label>
                        <input
                            className={`form-input w-full ${errors?.City ? "border-red-500" : ""}`}
                            type="text"
                            placeholder="Enter City"
                            value={City}
                            onChange={(e) => setCity(e.target.value)}
                        />
                        {errors?.City && (
                            <p className="text-red-500 text-sm mt-1">{errors?.City}</p>
                        )}
                    </div>

                    <div>
                        <label className="block mb-1 font-medium">
                            State<span className="text-red-500">*</span>
                        </label>
                        <input
                            className={`form-input w-full ${errors?.State ? "border-red-500" : ""}`}
                            type="text"
                            placeholder="Enter State"
                            value={State}
                            onChange={(e) => setState(e.target.value)}
                        />
                        {errors?.State && (
                            <p className="text-red-500 text-sm mt-1">{errors?.State}</p>
                        )}
                    </div>

                    <div>
                        <label className="block mb-1 font-medium">
                            Number of Labours<span className="text-red-500">*</span>
                        </label>
                        <input
                            className={`form-input w-full ${errors?.NumberOfLabours ? "border-red-500" : ""}`}
                            type="number"
                            placeholder="Enter number of labours"
                            value={NumberOfLabours}
                            onChange={(e) => setNumberOfLabours(e.target.value)}
                        />
                        {errors?.NumberOfLabours && (
                            <p className="text-red-500 text-sm mt-1">{errors?.NumberOfLabours}</p>
                        )}
                    </div>

                    <div>
                        <label className="block mb-1 font-medium">
                            Duration (in days)<span className="text-red-500">*</span>
                        </label>
                        <input
                            className={`form-input w-full ${errors?.DurationInDays ? "border-red-500" : ""}`}
                            type="number"
                            placeholder="Enter duration"
                            value={DurationInDays}
                            onChange={(e) => setDurationInDays(e.target.value)}
                        />
                        {errors?.DurationInDays && (
                            <p className="text-red-500 text-sm mt-1">{errors?.DurationInDays}</p>
                        )}
                    </div>

                    <div>
                        <label className="block mb-1 font-medium">
                            Per Day Rate<span className="text-red-500">*</span>
                        </label>
                        <input
                            className={`form-input w-full ${errors?.PerDayRate ? "border-red-500" : ""}`}
                            type="number"
                            placeholder="Enter rate per day"
                            value={PerDayRate}
                            onChange={(e) => setPerDayRate(e.target.value)}
                        />
                        {errors?.PerDayRate && (
                            <p className="text-red-500 text-sm mt-1">{errors?.PerDayRate}</p>
                        )}
                    </div>

                    <div className="md:col-span-2">
                        <label className="block mb-1 font-medium">Notes</label>
                        <textarea
                            className="form-input w-full"
                            placeholder="Additional notes (optional)"
                            value={Notes}
                            onChange={(e) => setNotes(e.target.value)}
                        />
                    </div>
                </div>

                <button
                    onClick={handleUpdateLobourJobPost}
                    disabled={IsLoading}
                    className={`w-full mt-8 text-white py-3 rounded-full font-medium transition 
          ${IsLoading ? "bg-gray-400 cursor-not-allowed" : "bg-gradient-to-r from-blue-500 to-red-500 hover:opacity-90"}`}
                >
                    {IsLoading ? "Updating..." : "Update Requirement"}
                </button>
            </div>
        </div>
    )
}

export default UpdateLobourJobPostModel